require('initializers/gettext').default(__TRANSLATIONS__.gettext.fr); // eslint-disable-line no-undef
require('initializers/i18n').default('fr', __TRANSLATIONS__.i18n.fr); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/fr');
require('jquery-ui/ui/i18n/datepicker-fr');
require('dayjs/locale/fr');
